export default function PageSubscribedCtrl($scope, $state, page) {
  'ngInject';

  const controller = this;
  controller.page = page;
  controller.fromManage = $state.current.name.indexOf('manage') >= 0;
}
